module.exports = __webpack_public_path__ + "img/gamma3_icon.b07704db.png";